import { useEffect, useState } from "react";


function Cookies() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("analyticsConsent");
    if (consent === null) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (accepted) => {
    localStorage.setItem("analyticsConsent", accepted ? "true" : "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed-bottom bg-white d-flex flex-md-row flex-column p-3 justify-content-center">

      <div className="d-flex flex-row align-items-center col-md-6">
        <img style={{maxHeight:'100px'}} alt="cookie kép" src="/cookie.webp" />
        <p className="m-0 ps-2 fs-5">Ez az oldal sütiket használ a jobb felhasználói élmény érdekében.</p>
      </div>


      <div className="d-flex flex-row flex-md-column col-lg-3 col-md-4 justify-content-around align-items-around">
        <button
          className="btn btn-primary me-2 me-md-0"
          onClick={() => handleConsent(true)}
        >
          Minden süti engedélyezése
        </button>
        <button
          className="btn btn-outline-secondary"
          onClick={() => handleConsent(false)}
        >
          Csak a szükséges sütik
        </button>
      </div>

    </div>
  );
}

export default Cookies;
